import React from 'react';
import { Link } from 'react-router';
import AppRoutes from '../../routes/routes';
import AuthRoutes from '../../routes/logged-in';
import LoginActions from '../../actions/login-actions';

export default function MarketingDrawer({ isOpen, onClose, userLoggedIn, user, trackNav }) {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target.className === 'marketing-drawer-overlay') {
            onClose();
        }
    };

    return (
        <div className="marketing-drawer-overlay" onClick={handleBackdropClick}>
            <aside className="marketing-drawer">
                <div className="drawer-header">
                    <Link to="/" className="nav-brand">
                        <img src={require('../../../images/logo.svg')} style={{ width: '90%', height: '28px' }} alt="Neurochecklists Logo" />
                    </Link>
                    <button className="drawer-close" onClick={onClose} aria-label="Close menu">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </button>
                </div>

                <div className="drawer-content">
                    {!userLoggedIn && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px', paddingBottom: '24px', borderBottom: '1px solid var(--border)' }}>
                            <button className="btn btn-primary-sm" onClick={() => window.location.href = '/home?modal=register'} style={{ width: '100%', justifyContent: 'center' }}>Get started</button>
                            <button className="btn btn-ghost-nav" onClick={() => window.location.href = '/home?modal=login'} style={{ width: '100%', justifyContent: 'center' }}>Log in</button>
                        </div>
                    )}

                    {userLoggedIn ? (
                        <nav className="drawer-nav">
                            <div style={{ width: '100%' }}>
                                <div className="drawer-nav-title">App</div>
                                <ul>
                                    <li><Link to={AppRoutes.explore} onClick={() => { trackNav('Explore'); onClose(); }}>Explore Dataset</Link></li>
                                    {!user.free_trial_expired && (
                                        <li><Link to="/chat" onClick={() => { trackNav('Axon'); onClose(); }}>Axon</Link></li>
                                    )}
                                    <li><Link to={AuthRoutes.bookmarks} onClick={() => { trackNav('Bookmarks'); onClose(); }}>Bookmarks</Link></li>
                                    <li><Link to={AuthRoutes.notes} onClick={() => { trackNav('Notes'); onClose(); }}>Notes</Link></li>
                                </ul>

                                <div className="drawer-nav-title">My Account</div>
                                <ul>
                                    <li><Link to={AuthRoutes.account} onClick={() => { trackNav('Account'); onClose(); }}>Account</Link></li>
                                    <li><Link to={AuthRoutes.guide} onClick={() => { trackNav('Guide'); onClose(); }}>Guide</Link></li>
                                    <li><a style={{ cursor: 'pointer' }} onClick={(e) => {
                                        e.preventDefault();
                                        if (user) {
                                            LoginActions.logout({
                                                'X-USER-EMAIL': user.email,
                                                'X-USER-TOKEN': user.authentication_token,
                                            });
                                        }
                                    }}>Sign Out</a></li>
                                </ul>

                                <div className="drawer-nav-title">Resources</div>
                                <ul>
                                    <li><a href={AppRoutes.substack} target="_blank" onClick={() => { trackNav('Substack'); onClose(); }} rel="noopener noreferrer">Substack</a></li>
                                    <li><a href={AppRoutes.news} target="_blank" onClick={() => { trackNav('The Neurology Lounge Podcast'); onClose(); }} rel="noopener noreferrer">The Neurology Lounge Podcast</a></li>
                                    <li><Link to={AppRoutes.surfing_the_brain_int} target="_blank" onClick={() => { trackNav('Surfing the Brain'); onClose(); }}>Surfing the Brain</Link></li>
                                    <li><a href={AppRoutes.book} target="_blank" onClick={() => { trackNav('700 Essential Neurology Checklists'); onClose(); }} rel="noopener noreferrer">700 Essential Neurology Checklists</a></li>
                                </ul>
                            </div>
                        </nav>
                    ) : (
                        <nav className="drawer-nav">
                            <ul>
                                <li><Link to={AppRoutes.explore} onClick={() => { trackNav('Explore'); onClose(); }}>Explore Dataset</Link></li>
                                <li><Link to={AppRoutes.axon} onClick={() => { trackNav('Axon'); onClose(); }}>Axon</Link></li>
                                <li><Link to={AppRoutes.about} onClick={() => { trackNav('About'); onClose(); }}>About</Link></li>
                                <li><Link to={AppRoutes.pricing} onClick={() => { trackNav('Pricing'); onClose(); }}>Pricing</Link></li>
                                <li><a href={AppRoutes.substack} target="_blank" onClick={() => { trackNav('Substack'); onClose(); }} rel="noopener noreferrer">Substack</a></li>
                                <li><a href={AppRoutes.news} target="_blank" onClick={() => { trackNav('The Neurology Lounge Podcast'); onClose(); }} rel="noopener noreferrer">The Neurology Lounge Podcast</a></li>
                                <li><Link to={AppRoutes.surfing_the_brain_int} target="_blank" onClick={() => { trackNav('Surfing the Brain'); onClose(); }}>Surfing the Brain</Link></li>
                                <li><a href={AppRoutes.book} target="_blank" onClick={() => { trackNav('700 Essential Neurology Checklists'); onClose(); }} rel="noopener noreferrer">700 Essential Neurology Checklists</a></li>
                            </ul>
                        </nav>
                    )}

                </div>

            </aside>
        </div>
    );
}
